// TODO - remove becouse of legacy

import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'

export type FetchFailedFulfillmentCsvReportAction = FSA<undefined, undefined, string>
type FetchFailedFulfillmentCsvReport = (campaignId: number) => MrxThunk<FetchFailedFulfillmentCsvReportAction, Promise<string>>
type QueryResponse = GraphQLResponse<'failedFulfillmentReportExportToCSV', string>

const FETCH_FAILED_FULFILLMENT_CSV_REPORT = `
  query FailedFulfillmentReportExportToCSV($campaignId: Int!) {
    failedFulfillmentReportExportToCSV(campaignId: $campaignId)
  }
`

const fetchFailedFulfillmentCsvReport: FetchFailedFulfillmentCsvReport = (campaignId) => async (dispatch) => {
  dispatch({
    type: t.FETCH_FAILED_FULFILLMENT_CSV_REPORT,
    meta: { done: false }
  })

  try {
    if (!campaignId) {
      throw new Error('Please select campaign!')
    }

    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_FAILED_FULFILLMENT_CSV_REPORT,
      variables: { campaignId }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { failedFulfillmentReportExportToCSV } = data
    if (!failedFulfillmentReportExportToCSV) {
      throw new Error("Can't fetch failed fulfillment CSV file url!")
    }

    dispatch({
      type: t.FETCH_FAILED_FULFILLMENT_CSV_REPORT,
      meta: { done: true },
      payload: undefined
    })
    return failedFulfillmentReportExportToCSV
  } catch (err) {
    dispatch({
      type: t.FETCH_FAILED_FULFILLMENT_CSV_REPORT,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchFailedFulfillmentCsvReport }
